/**
 * 艺术家的数据模拟
 * @type {[{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{menuChild: [{img: {}, imgTitle: string, material: string, author: string, styleOption: [{name: string, key: string},{name: string, key: string},{name: string, key: string},{name: string, key: string},{name: string, key: string},null,null], title: string, dimension: string, key: string, age: string, desc: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string}]},{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string},{menuChild: [{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string},{title: string, key: string}], title: string, key: string}]},{descList: [{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string},{img: {}, material: string, author: string, title: string, dimension: string, key: string, age: string, desc: string}], title: string, key: string, child: [{title: string, key: string},{title: string, key: string},{title: string, key: string}]}]}
 */
export const tabsOption = [
  {
    key: "intro",
    title: "集团简介",
    menuChild: [
      {
        key: "corporateCulture",
        title: "企业文化"
      },
      {
        key: "organizationalStructure",
        title: "组织架构",
        itemList: []
      },
      {
        key: "aptitude",
        title: "荣誉资质"
      }
    ]
  },
  {
    key: "news",
    title: "集团新闻",
    menuChild: [],
    itemList: []
  },
  {
    key: "announcement",
    title: "公示公告",
    menuChild: [],
    itemList: []
  },
  {
    key: "industryDynamics",
    title: "行业动态",
    menuChild: [],
    itemList: []
  },
  {
    key: "mediaReport",
    title: "媒体报道",
    menuChild: [],
    itemList: []
  },
  {
    key: "videoData",
    title: "视频资料",
    menuChild: [],
    itemList: []
  },
  {
    key: "documentData",
    title: "文件下载",
    menuChild: [],
    itemList: []
  }
];
